(function () {
  const drawer = document.getElementById('TwCartDrawer');
  const itemsContainer = document.getElementById('TwCartDrawerItems');
  const subtotalEl = document.getElementById('TwCartDrawerSubtotal');
  const emptyEl = document.getElementById('TwCartDrawerEmpty');
  const footerEl = drawer?.querySelector('.tw-cart-drawer__footer');
  const shippingRowEl = document.getElementById('TwCartDrawerShippingRow');
  const isCartPage = window.location.pathname === '/cart';

  const shippingEl = document.getElementById('TwCartDrawerShipping');
  const shippingTextEl = document.getElementById('TwCartDrawerShippingText');
  const shippingFillEl = document.getElementById('TwCartDrawerShippingFill');

  if (!drawer) return;

  function formatMoney(cents) {
    return new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: 'GBP'
    }).format(cents / 100);
  }

  function stripRichText(html) {
    if (!html) return '';

    return html
      .replace(/<\/?p[^>]*>/g, '')
      .replace(/\n/g, '')
      .trim();
  }

  function openDrawer() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function setLoading(isLoading) {
    drawer.classList.toggle('is-loading', isLoading);
  }

  function setEmptyState(isEmpty) {
    drawer.classList.toggle('is-empty', isEmpty);

    if (emptyEl) emptyEl.hidden = !isEmpty;
    if (footerEl) footerEl.hidden = isEmpty;
  }

  function renderFreeShipping(cart) {
    if (!shippingEl || !shippingTextEl || !shippingFillEl) return;

    const threshold = Number(shippingEl.dataset.threshold);

    if (!threshold || threshold <= 0) {
      shippingEl.style.display = 'none';
      if (shippingRowEl) shippingRowEl.hidden = true;
      return;
    }

    const total = cart.total_price;
    const remaining = Math.max(0, threshold - total);
    const percentage = Math.min(100, (total / threshold) * 100);

    const msgStart = stripRichText(shippingEl.dataset.msgStart || 'You are');
    const msgEnd = stripRichText(shippingEl.dataset.msgEnd || 'away from FREE SHIPPING');
    const msgQualified = stripRichText(
      shippingEl.dataset.msgQualified || 'You have qualified for free shipping'
    );

    shippingEl.style.display = 'block';
    shippingFillEl.style.width = `${percentage}%`;

    if (remaining <= 0) {
      shippingEl.classList.add('is-complete');
      shippingTextEl.innerHTML = msgQualified;

      if (shippingRowEl) shippingRowEl.hidden = false;
    } else {
      shippingEl.classList.remove('is-complete');
      shippingTextEl.innerHTML = `${msgStart} <strong>${formatMoney(remaining)}</strong> ${msgEnd}`;

      if (shippingRowEl) shippingRowEl.hidden = true;
    }
  }

  function renderCart(cart) {
    if (!itemsContainer || !subtotalEl) return;

    const isEmpty = !cart.items || cart.items.length === 0;

    subtotalEl.textContent = formatMoney(cart.total_price);
    renderFreeShipping(cart);
    setEmptyState(isEmpty);

    if (isEmpty) {
      itemsContainer.innerHTML = '';
      if (shippingRowEl) shippingRowEl.hidden = true;
      return;
    }

    itemsContainer.innerHTML = cart.items.map((item, index) => {
      const line = index + 1;

      const image = item.image
        ? `<img src="${item.image}" alt="${item.product_title}" class="tw-cart-drawer-item__image">`
        : '';

      const variantTitle = item.variant_title && item.variant_title !== 'Default Title'
        ? `<p class="tw-cart-drawer-item__variant">${item.variant_title}</p>`
        : '';

      return `
        <div class="tw-cart-drawer-item" data-cart-line="${line}">
          <div class="tw-cart-drawer-item__media">
            ${image}
          </div>

          <div class="tw-cart-drawer-item__content">
            <div class="tw-cart-drawer-item__top">
              <p class="tw-cart-drawer-item__title">${item.product_title}</p>

              <button
                type="button"
                class="tw-cart-drawer-item__remove"
                data-cart-remove
                data-line="${line}"
                aria-label="Remove ${item.product_title}"
              >
                ×
              </button>
            </div>

            ${variantTitle}

            <div class="tw-cart-drawer-item__bottom">
              <div class="tw-cart-drawer-qty">
                <button
                  type="button"
                  class="tw-cart-drawer-qty__button"
                  data-cart-qty-minus
                  data-line="${line}"
                  data-quantity="${item.quantity}"
                  aria-label="Decrease quantity"
                >
                  −
                </button>

                <span class="tw-cart-drawer-qty__value">${item.quantity}</span>

                <button
                  type="button"
                  class="tw-cart-drawer-qty__button"
                  data-cart-qty-plus
                  data-line="${line}"
                  data-quantity="${item.quantity}"
                  aria-label="Increase quantity"
                >
                  +
                </button>
              </div>

              <strong class="tw-cart-drawer-item__price">
                ${formatMoney(item.final_line_price)}
              </strong>
            </div>
          </div>
        </div>
      `;
    }).join('');
  }

  function updateEmptyProductVariant(select) {
    const productCard = select.closest('.tw-cart-drawer-empty-product');
    if (!productCard) return;

    const selectedOption = select.options ? select.options[select.selectedIndex] : null;
    const addButton = productCard.querySelector('[data-cart-drawer-add]');
    const priceEl = productCard.querySelector('[data-cart-drawer-product-price]');

    if (addButton) {
      addButton.dataset.variantId = select.value;
      addButton.disabled = selectedOption ? selectedOption.disabled : false;
      addButton.textContent = selectedOption && selectedOption.disabled ? 'Sold out' : 'Add';
    }

    if (priceEl && selectedOption && selectedOption.dataset.price) {
      priceEl.textContent = selectedOption.dataset.price;
    }
  }

  async function refreshCart() {
    if (window.theoremCart && typeof window.theoremCart.getCart === 'function') {
      return await window.theoremCart.getCart();
    }

    const response = await fetch('/cart.js');
    const cart = await response.json();

    renderCart(cart);

    return cart;
  }

  async function changeLineQuantity(line, quantity) {
    if (!window.theoremCart) return;

    setLoading(true);

    try {
      await window.theoremCart.changeItem({
        line: Number(line),
        quantity: Number(quantity)
      });

      await refreshCart();
    } catch (error) {
      console.error('Cart drawer update error:', error);
    } finally {
      setLoading(false);
    }
  }

  async function addVariantToCart(variantId, button) {
    if (!window.theoremCart || !variantId) return;

    setLoading(true);

    if (button) {
      button.disabled = true;
      button.dataset.originalText = button.textContent;
      button.textContent = 'Adding...';
    }

    try {
      await window.theoremCart.addItem({
        items: [
          {
            id: Number(variantId),
            quantity: 1
          }
        ]
      });

      await refreshCart();
    } catch (error) {
      console.error('Add from cart drawer error:', error);
    } finally {
      setLoading(false);

      if (button) {
        button.disabled = false;
        button.textContent = button.dataset.originalText || 'Add';
      }
    }
  }

  function bindCartIcon() {
    const cartTriggers = document.querySelectorAll('[data-cart-drawer-trigger]');

    cartTriggers.forEach((trigger) => {
      trigger.addEventListener('click', async function (event) {
        event.preventDefault();

        setLoading(true);

        try {
          const cart = await refreshCart();
          renderCart(cart);
          openDrawer();
        } catch (error) {
          console.error('Cart drawer open error:', error);
          window.location.href = trigger.getAttribute('href') || '/cart';
        } finally {
          setLoading(false);
        }
      });
    });
  }

  document.querySelectorAll('[data-cart-drawer-close]').forEach((button) => {
    button.addEventListener('click', closeDrawer);
  });

  itemsContainer?.addEventListener('click', function (event) {
    const minusButton = event.target.closest('[data-cart-qty-minus]');
    const plusButton = event.target.closest('[data-cart-qty-plus]');
    const removeButton = event.target.closest('[data-cart-remove]');

    if (minusButton) {
      const line = minusButton.dataset.line;
      const currentQuantity = Number(minusButton.dataset.quantity);
      const newQuantity = Math.max(currentQuantity - 1, 0);

      changeLineQuantity(line, newQuantity);
    }

    if (plusButton) {
      const line = plusButton.dataset.line;
      const currentQuantity = Number(plusButton.dataset.quantity);
      const newQuantity = currentQuantity + 1;

      changeLineQuantity(line, newQuantity);
    }

    if (removeButton) {
      const line = removeButton.dataset.line;

      changeLineQuantity(line, 0);
    }
  });

  document.addEventListener('change', function (event) {
    const variantSelect = event.target.closest('[data-cart-drawer-variant-select]');
    if (!variantSelect) return;

    updateEmptyProductVariant(variantSelect);
  });

  document.addEventListener('click', function (event) {
    const addButton = event.target.closest('[data-cart-drawer-add]');
    if (!addButton) return;

    const variantSelect = addButton
      .closest('.tw-cart-drawer-empty-product')
      ?.querySelector('[data-cart-drawer-variant-select]');

    const variantId = variantSelect ? variantSelect.value : addButton.dataset.variantId;

    addVariantToCart(variantId, addButton);
  });

  document.addEventListener('cartUpdated', function (event) {
    const cart = event.detail && event.detail.newCart;

    if (!cart) return;

    renderCart(cart);

    if (!isCartPage) {
      openDrawer();
    }
  });

  bindCartIcon();

  window.twCartDrawer = {
    open: openDrawer,
    close: closeDrawer,
    render: renderCart,
    refresh: refreshCart
  };
})();